
import { IKeHoachMonHocNamHocHocKyActionTypes } from "../../action-types/ke-hoach/IKeHoachMonHocNamHocHocKy";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachMonHocNamHocHocKyReducer } from "../../reducer-model/ke-hoach/IKeHoachMonHocNamHocHocKyReducer";
const iniState: IKeHoachMonHocNamHocHocKyReducer = {
    chuongTrinhDaoTaos: []
};
export const keHoachMonHocNamHocHocKyReducer = (
    state: IKeHoachMonHocNamHocHocKyReducer = iniState,
    action: IKeHoachMonHocNamHocHocKyActionTypes
): IKeHoachMonHocNamHocHocKyReducer => {
    const id_dt = action?.payload?.id_dt ?? 0;
    switch (action.type) {
        case "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY_INI_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [id_dt]: {
                        id_dt,
                        status: eReducerStatusBase.is_not_initialization,
                        statusKeHoachMon: eReducerStatusBase.is_need_reload,
                        keHoachMons: []
                    }
                }
            };

        case "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY_LOAD_KE_HOACH_MON_BY_CTDT_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [id_dt]: {
                        ...state.chuongTrinhDaoTaos[id_dt],
                        statusKeHoachMon: eReducerStatusBase.is_loading
                    }
                }
                // chuongTrinhDaoTaos: state.chuongTrinhDaoTaos.map(ctdt => {
                //     if (ctdt.id_dt === action.payload.id_dt) {
                //         return {
                //             ...ctdt,
                //             statusKeHoachMon: eReducerStatusBase.is_loading
                //         }
                //     }
                //     return ctdt;
                // })
            };
        case "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY_LOAD_KE_HOACH_MON_BY_CTDT_SUCCESS":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [id_dt]: {
                        ...state.chuongTrinhDaoTaos[id_dt],
                        statusKeHoachMon: eReducerStatusBase.is_completed,
                        keHoachMons: action.payload.data
                    }
                }
                // chuongTrinhDaoTaos: state.chuongTrinhDaoTaos.map(ctdt => {
                //     if (ctdt.id_dt === action.payload.id_dt) {
                //         return {
                //             ...ctdt,
                //             statusKeHoachMon: eReducerStatusBase.is_completed,
                //             keHoachMons: action.payload.data
                //         }
                //     }
                //     return ctdt;
                // })
            };
        case "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY_LOAD_KE_HOACH_MON_BY_CTDT_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [id_dt]: {
                        ...state.chuongTrinhDaoTaos[id_dt],
                        statusKeHoachMon: eReducerStatusBase.is_completed
                    }
                }
                // chuongTrinhDaoTaos: state.chuongTrinhDaoTaos.map(ctdt => {
                //     if (ctdt.id_dt === action.payload.id_dt) {
                //         return {
                //             ...ctdt,
                //             statusKeHoachMon: eReducerStatusBase.is_completed,
                //         }
                //     }
                //     return ctdt;
                // })
            };

        default:
            return state;
    }
};
